<template>
  <modal :active="active" @close="handleCloseModal">
    <div v-if="actionType == 'createModal'" slot="title">
      Create New Plan Report
    </div>
    <div v-else slot="title">Update Plan Report</div>
    <div class="col-12">
      <div class="col-12" style="margin-top: 10px">
        <label>Summary</label>
        <textarea class="form-control" type="text" required v-model="summary" />
      </div>
      <div class="col-12" style="margin-top: 10px; display: flex">
        <div class="col-6" style="padding-left: 0">
          <label>ROI (%)</label>
          <input
            class="form-control"
            type="number"
            placeholder="Example 10"
            required
            v-model="roi"
          />
        </div>
        <div class="col-6" style="padding-right: 0">
          <label>Grade</label>
          <input
            class="form-control"
            type="text"
            placeholder="A+, A, B+, B ..."
            required
            v-model="grade"
          />
        </div>
      </div>
      <div class="col-12" style="margin-top: 10px; display: flex">
        <div class="col-6" style="padding-left: 0">
          <label>Year</label>
          <input class="form-control" type="text" required v-model="year" />
        </div>
        <div class="col-6" style="padding-right: 0">
          <label>Status</label>
          <select class="custom-select" v-model="status">
            <option
              v-for="status in statusList"
              :key="status.name"
              :value="status.id"
            >
              {{ status.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" class="btn btn-danger" @click="init()">
        Reset
      </button>
      <button type="button" class="btn btn-success" @click="handleSave()">
        Save
      </button>
    </div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import PlanReportStorer from "../../../../storers/StorePlanReport";
import { mapState } from "vuex";
export default {
  data() {
    return {
      summary: null,
      year: null,
      roi: null,
      grade: null,
      status: "draft",
      statusList: [
        { id: "draft", name: "Draft" },
        { id: "published", name: "Published" },
      ],
    };
  },
  props: {
    active: Boolean,
    actionType: String,
    activePlanReport: Object,
  },
  components: { Spinner, Modal },
  created: function () {},
  computed: {
    ...mapState({}),
  },
  methods: {
    init() {
      this.summary = null;
      this.grade = null;
      this.roi = null;
      this.status = "draft";
    },

    fillForm() {
      this.summary = this.activePlanReport.summary;
      this.grade = this.activePlanReport.grade;
      this.roi = this.activePlanReport.roi;
      this.year = this.activePlanReport.year;
      this.status = this.activePlanReport.status;
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    handleSave() {
      var planReport = PlanReportStorer();
      if (this.actionType == "updateModal") {
        planReport.id = this.activePlanReport.id;
        planReport.plan_id = this.activePlanReport.plan_id;
      }
      planReport.summary = this.summary;
      planReport.grade = this.grade;
      planReport.roi = this.roi;
      planReport.year = this.year;
      planReport.status = this.status;
      this.$emit("saveRequest", planReport);
      this.init();
    },
  },
  watch: {
    actionType() {
      this.init();
      if (this.actionType == "updateModal") {
        this.fillForm();
      }
    },
    active() {
      if (this.actionType == "createModal") {
        this.year = new Date().getFullYear();
      }
    },
  },
};
</script> 
 <style>
.image-upload > input {
  display: none;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/planReportModal.vue